<template>
  <div class="">
    <div class="head-title">在职继承</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>
            1、员工调岗后，企业可将此员工的客户、客户群分配转移给其他员工，客户无需操作确认即可直接完成转交。
          </p>
          <p>
            2、为了保障客户的服务体验和提升企业服务的稳定性，在职成员的每位客户最多被分配2次。客户被转接成功后，将有90个自然日的服务关系保护期，保护期内的客户无法再次被分配。
            注：在职继承的次数等限制不影响离职继承功能的使用。
          </p>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="mMain">
      <nav class="navbar">
        <div class="nav-l">
          <el-button type="primary" icon="el-icon-notebook-2" @click="onToList"
            >继承记录</el-button
          >
        </div>
        <div class="nav-r">
          <el-input
            clearable
            style="width: 35.0rem"
            placeholder="请输入成员名称搜索"
            prefix-icon="el-icon-search"
            v-model="input2"
            @change="userTable"
          ><el-button slot="append" @click="userTable" type="primary"
            >查询</el-button
          >
          </el-input>

        </div>
      </nav>
      <el-table
        :data="tableData.data"
        border
        style="width: 100%; margin-top: 2.0rem"
        v-loading="tableLoading"
      >
        <el-table-column prop="avatar" label="成员头像" style="width:16.66%">
          <template slot-scope="scope">
            <el-image
              style="width: 3.2rem; height: 3.2rem"
              :src="scope.row.avatar"
              :preview-src-list="[scope.row.avatar]"
              fit="scale-down"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="成员名称"
          style="width:16.66%"
        ></el-table-column>

        <el-table-column
        style="width:16.66%"
          prop="department_name"
          label="部门"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag
              size="mini"
              style="margin: .2rem"
              v-for="t in scope.row.tags"
              :key="t"
              >{{ t }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="customer_count"
          label="客户数"
          style="width:16.66%"
        ></el-table-column>
        <el-table-column
          prop="chat_count"
          label="客户群数"
          style="width:16.66%"
        ></el-table-column>
        <el-table-column label="操作" width="300" fixed="right">
          <template slot-scope="scope">
            <el-button
              @click="handleAssignment(scope.row)"
              type="text"
              size="mini"
              >分配客户</el-button
            >
            <el-button
              @click="handleGroup(scope.row)"
              type="text"
              size="mini"
              >分配群</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="paging">
        <pagination
          :total="tableData.total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          :page-sizes="[10,20,50,100]"
          :auto-scroll="false"
          @pagination="userTable"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import Pagination from "@/components/Pagination";
export default {
  name: "monitoring",
  components: {
    Pagination,
  },
  data() {
    return {
      title: {},
      tooken: "",
      tableData: {
        total: 0,
        data: [],
      },
      input2: "",
      onSubmit: false,
      onSubmitn: false,
      tableData_a: [],
      multipleSelection: [],
      value1: true,
      form: {
        name: "",
        none: "",
        customer_deal_days: "",
        customer_follow_days: "",
      },
      ele: "",
      yeshu: 1,
      bianjile: "",
      customer_deal_days: "",
      customer_follow_days: "",
      lock: true,
      code: "",
      listQuery: {
        page: 1,
        limit: 20,
      },
      tableLoading: true,
    };
  },
  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.userTable();
  },
  methods: {
    onToList() {
      this.$router.push({
        name: "departureInheritanceList2",
      });
    },
    handleAssignment(row) {
      this.$router.push({
        name: "departureInheritanceDetail2",
        query: {
          userid: row.userid,
          name: row.name,
          department_name: row.department_name,
        },
      });
    },
    handleGroup(row) {
      this.$router.push({
        name: "departureInheritanceGroup",
        query: {
          userid: row.userid,
          name: row.name,
          department_name: row.department_name,
        },
      });
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
    //  页数
    handleCurrentChange(val) {
      this.pageSize = val;
      this.userTable();
    },
    userTable() {
      this.axios
        .post(
          "/crm/Assistant/getAddressBook",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.input2,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          res.data.data.data.forEach((i) => {
            const regex = /，|,/gim;
            const tags = i.department_name.replace(regex, ",");
            i.tags = tags.split(",");
          });
          this.tableLoading = false;
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
    },
    rune() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/Dimission/getAddressBook2",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.input2,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
    },
    tianjia() {
      this.yeshu = 1;
      this.axios
        .post(
          "/home/sessionUser/ifRemoveUserTwo",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) {});
    },

    handleSelectionChange(val) {
      this.yeshu = 1;
      this.multipleSelection = val;
    },
    bianji(e, o, l, p) {
      this.yeshu = 1;
      this.ele = e;
      this.bianjile = o;
      this.customer_follow_days = l;
      this.customer_deal_days = p;
    },
    // 修改
    numoon() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/CustomerLevel/editCustomerLevel",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.bianjile,
            id: this.ele,
            customer_follow_days: this.customer_follow_days,
            customer_deal_days: this.customer_deal_days,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmitn = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.onSubmitn = true;
            this.$message.error(res.data.msg);
          }
          this.userTable();
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) {});
    },
    // 添加
    numoo() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/CustomerLevel/addCustomerLevel",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.form.name,
            customer_follow_days: this.form.customer_follow_days,
            customer_deal_days: this.form.customer_deal_days,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmit = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.onSubmit = true;
            this.$message.error(res.data.msg);
          }
          this.userTable();
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) {});
    },
    // 移除
    handleClick(e, o) {
      this.yeshu = 1;
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/crm/CustomerLevel/delCustomerLevel",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                id: e,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.userTable();
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.tableData_a = res.data.data;
            })
            .catch(function (err) {});
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped>
.groupSend {
  height: 100%;
}
.hello {
  width: 100%;
  height: 100%;
  padding: 2.0rem;
  overflow: hidden;
  overflow-y: auto;
}
nav {
  width: 100%;
}
.shij {
  display: inline-block;
  margin-right: 2.4rem;
}
.wei_body {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  -webkit-box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  padding: 2.3rem 3.1rem;
  overflow: hidden;
  overflow-y: auto;
}

.menus {
  margin-left: 2.0rem;
  margin-bottom: 2.0rem;
}

::v-deep .has-gutter > tr:nth-child(1) > th > .cell > label {
  display: none;
}
</style>
